import { render } from "./NotificationBell.vue?vue&type=template&id=97f0b720&scoped=true&ts=true"
import script from "./NotificationBell.vue?vue&type=script&lang=ts"
export * from "./NotificationBell.vue?vue&type=script&lang=ts"

import "./NotificationBell.vue?vue&type=style&index=0&id=97f0b720&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f0b720"]])

export default __exports__